import React, { useState } from 'react';
import './Services.css';

const TREE = [
  { id: 'cloud',    label: 'cloud/',         sub: ['migration.tf', 'architecture.md'] },
  { id: 'pipeline', label: 'pipelines/',     sub: ['ci-cd.yaml', 'gitops.md'] },
  { id: 'observe',  label: 'observability/', sub: ['prometheus.yml', 'grafana.json'] },
  { id: 'k8s',      label: 'kubernetes/',    sub: ['helm-charts/', 'eks.tf'] },
  { id: 'security', label: 'security/',      sub: ['zero-trust.md', 'iam.tf'] },
  { id: 'ai',       label: 'ai-infra/',      sub: ['vertex-ai.py', 'openai.tf'] },
];

const SERVICES = {
  cloud:    { num: '01', title: 'Cloud infrastructure', desc: 'Architecture reviews, cost reduction and workload migrations across AWS, Azure and GCP. Full ownership from design to production.' },
  pipeline: { num: '02', title: 'CI/CD and GitOps',     desc: 'End-to-end pipeline automation with ArgoCD, Bitbucket, CodePipeline and Helm. Zero-touch deployments that actually work.' },
  observe:  { num: '03', title: 'Observability',        desc: 'Prometheus, Grafana, Loki and Tempo — alerting, dashboards and SLO definitions that reflect how your system actually behaves.' },
  k8s:      { num: '04', title: 'Kubernetes',           desc: 'Deploying and hardening workloads on EKS, GKE and Docker with Helm. Cluster setup, RBAC, autoscaling and cost optimisation.' },
  security: { num: '05', title: 'Zero Trust security',  desc: 'Zscaler, IAM, Secrets Manager and Microsoft Defender wired into your stack. Security that does not slow your team down.' },
  ai:       { num: '06', title: 'AI infrastructure',    desc: 'Vertex AI and Azure OpenAI in production with proper scaling, monitoring and cost controls. LLM pipelines that hold under load.' },
};

export default function Services() {
  const [active, setActive] = useState('cloud');
  const svc = SERVICES[active];

  return (
    <section id="consulting" className="services">
      <div className="services-bar">
        <span className="services-label">// services/</span>
      </div>
      <div className="services-body">
        <div className="file-tree">
          {TREE.map(item => (
            <div key={item.id}>
              <div
                className={`tree-item ${active === item.id ? 'active' : ''}`}
                onClick={() => setActive(item.id)}
              >
                <span className="tree-arrow">{active === item.id ? '▾' : '▸'}</span>
                {item.label}
              </div>
              {active === item.id && item.sub.map((s, i) => (
                <div key={i} className="tree-sub">{s}</div>
              ))}
            </div>
          ))}
        </div>
        <div className="service-detail">
          <div className="svc-num">{svc.num}</div>
          <h2 className="svc-title">{svc.title}</h2>
          <p className="svc-desc">{svc.desc}</p>
          <a href="#contact" className="svc-cta">get in touch ↗</a>
        </div>
      </div>
    </section>
  );
}
